import React from "react";
import {
  formatDate,
  stringToColor,
  normalizeLabel,
  getDirection,
  isRecent,
} from "../../utils/messageUtils";

const CLAMP_LENGTH = 260;

function MessageCard({ name, country, city, message, date, onClick, labels }) {
  const [expanded, setExpanded] = React.useState(false);
  const isLongMessage = message && message.length > CLAMP_LENGTH;
  const countryLabel = normalizeLabel(country);
  const cityLabel = normalizeLabel(city);
  const location = [cityLabel, countryLabel].filter(Boolean).join(", ");
  const avatarColor = stringToColor(name || countryLabel || "Guest");
  const avatarInitial = (name || countryLabel || "?")
    .trim()
    .charAt(0)
    .toUpperCase();

  const handleCardClick = (e) => {
    if (e.target.closest("button")) return;
    if (onClick) onClick();
  };

  const handleKeyDown = (e) => {
    if (onClick && (e.key === "Enter" || e.key === " ") && e.target === e.currentTarget) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <article
      className="note-card"
      onClick={handleCardClick}
      onKeyDown={handleKeyDown}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <div className="note-card-tape" aria-hidden="true" />
      <header className="note-card-header" dir={getDirection(name)}>
        <span
          className="note-card-avatar"
          style={{ background: avatarColor }}
          aria-hidden="true"
        >
          {avatarInitial}
        </span>
        <div className="note-card-id">
          <span className="note-card-name">{name || "Guest"}</span>
          {location && <span className="note-card-location">{location}</span>}
        </div>
        {isRecent(date) && (
          <span className="note-card-new">{labels.newBadge}</span>
        )}
      </header>
      <p
        className={`note-card-message ${expanded ? "" : "is-clamped"}`}
        dir={getDirection(message)}
      >
        {message}
      </p>
      {isLongMessage && (
        <button
          type="button"
          className="note-card-expand"
          onClick={() => setExpanded((v) => !v)}
        >
          {expanded ? labels.showLess : labels.readMore}
        </button>
      )}
      {date && <footer className="note-card-date">{formatDate(date)}</footer>}
    </article>
  );
}

export default MessageCard;
